import { serverApi } from 'services/constante.js';

// Configurações para WhatsApp
export const whatsappConfig = {
    // URL do webhook do n8n
    webhookUrl: serverApi.urlN8N + '/envia-codigo-autenticacao-wp',
    
    // API Key para autenticação
    apiKey: serverApi.apiKeyN8N,
    
    // Número de teste para desenvolvimento
    testNumber: '51981438348',
    
    // Headers padrão para as requisições
    headers: {
        'x-api-key': serverApi.apiKeyN8N,
        'Content-Type': 'application/json'
    }
};

// Função utilitária para enviar mensagem WhatsApp
export const sendWhatsAppMessage = async (api, number, code) => {
    try {
        const data = JSON.stringify({
            number: number,
            code: code
        });
        
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: whatsappConfig.webhookUrl,
            headers: whatsappConfig.headers,
            data: data
        };

        const response = await api(config);
        return {
            success: true,
            data: response.data
        };
        
    } catch (error) {
        console.error("Erro ao enviar mensagem WhatsApp:", error);
        return {
            success: false,
            error: error.message
        };
    }
};

// Função para enviar mensagem de teste
export const sendTestMessage = async (api) => {
    const testMessage = "Teste de mensagem de notificações\n\n*Olá* _mundo!_";
    return await sendWhatsAppMessage(api, whatsappConfig.testNumber, testMessage);
}; 